<link rel="ractive" href="../components/placeholder-skeleton.html" name="c-placeholder-skeleton">

<div class="c-gp-results-table-output">
	<div class="results-table-wrapper" on-scroll="@this.hideSetLocationButton(@event)">
		<table
			class="results-table {{#if targetsCnt === 1}}single-target{{/if}} {{#if testType === 'dns'}}dns-results{{/if}}"
			style="grid-template-columns: minmax(0, 300px) minmax(120px, 1fr) repeat({{tableColumns.length}}, auto);"
		>
			<thead class="results-table_header">
				<tr>
					<th class="results-table_header_cell location" scope="col">
						<button type="button" on-click="@this.onSortClick('location')">
							Location
							<img width="8" alt="" src="{{@shared.assetsHost}}/img/{{@this.getSortIcon('location')}}">
						</button>
					</th>

					{{#if targetsCnt > 1}}
						<th class="results-table_header_cell targets" scope="col"></th>
					{{/if}}

					{{#each tableColumns as column}}
						{{#if column.type === 'timings'}}
							<th class="results-table_header_cell {{column.className}}" scope="col">
								<div class="timings-group">
									{{#each column.timings as timing}}
										{{#if timing.sortable !== false}}
											<button type="button" class="rtt_text" on-click="@this.onSortClick(timing.key)">
												{{timing.label}}
												<img width="8" alt="" src="{{@shared.assetsHost}}/img/{{@this.getSortIcon(timing.key)}}">
											</button>
										{{else}}
											<span class="rtt_text">{{timing.label}}</span>
										{{/if}}

										{{#unless timing.isLast}}
											<span class="rtt_separator">/</span>
										{{/unless}}
									{{/each}}
								</div>
							</th>
						{{elseif column.sortable !== false}}
							<th class="results-table_header_cell {{column.className}}" scope="col">
								<button type="button" on-click="@this.onSortClick(column.key)">
									{{column.label}}
									<img width="8" alt="" src="{{@shared.assetsHost}}/img/{{@this.getSortIcon(column.key)}}">
								</button>
							</th>
						{{else}}
							<th class="results-table_header_cell {{column.className}}" scope="col">{{column.label}}</th>
						{{/if}}
					{{/each}}
				</tr>
			</thead>

			{{#each preparedTestResults as result}}
				<tbody class="results-table_row row-num-{{result.clientSideId}} item-id-{{result.clientSideId}} {{#if @this.hasMultilineDnsAnswers(result)}}has-multiline-answers{{/if}}"
					{{#if targetsCnt === 1}}
						tabindex="0"
						aria-label="Set as location for the next test"
						on-focus="@this.enableItemFocused(@event, result.clientSideId)"
						on-blur="@this.hideSetLocationButton(@event)"
						on-keydown="@this.headerKeydownHandler(@event, result.clientSideId)"
					{{/if}}
					on-mouseenter="@this.showSetLocationButton(result.clientSideId)"
					on-mouseleave="@this.hideSetLocationButton(@event)"
					{{#if targetsCnt === 1}}
						style="background-image: linear-gradient(to right, {{_.getGpTargetStatusColor(result.statsPerTarget[0], testType, isInfiniteModeRes)}}0C, transparent 50%);"
					{{/if}}
				>
					{{#each result.statsPerTarget as target : targetIdx}}
						<tr class="results-table_row_stats_subrow target-{{targetIdx}}">
							{{#if targetIdx === 0}}
								<td
									class="results-table_row_location {{#if targetsCnt === 1}}results-table_status-line-host{{/if}}"
									rowspan="{{result.statsPerTarget.length}}"
									{{#if targetsCnt > 1}}
										tabindex="0"
										aria-label="Set as location for the next test"
										on-focus="@this.enableItemFocused(@event, result.clientSideId)"
										on-blur="@this.hideSetLocationButton(@event)"
										on-keydown="@this.headerKeydownHandler(@event, result.clientSideId)"
									{{/if}}
									{{#if targetsCnt === 1}}
										style="border-left: 0 solid {{_.getGpTargetStatusColor(result.statsPerTarget[0], testType, isInfiniteModeRes)}};"
									{{/if}}>
									<div class="results-table_row_location_content">
										<img width="28" height="20" alt="" src="https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/{{result.country}}.svg">

										<div class="results-table_row_location_data">
											<span>{{result.city}}, {{result.country}}, {{result.continent}}</span>
											<span>{{result.network}}</span>
										</div>
									</div>
								</td>
							{{/if}}

							{{#if targetsCnt > 1}}
								<td
									class="results-table_row_stats_subrow_cell results-table_status-line-host cell targets"
									style="border-left: 0 solid {{_.getGpTargetStatusColor(target, testType, isInfiniteModeRes)}}; background-image: linear-gradient(to right, transparent 6px, {{_.getGpTargetStatusColor(target, testType, isInfiniteModeRes)}}0C 12px, transparent 50%);">
									<div class="cell-value">
										{{#if target.target}}
											<span>{{target.target}}</span>
										{{elseif testInProgress}}
											<c-placeholder-skeleton type="base"></c-placeholder-skeleton>
										{{else}}
											<span>&mdash;</span>
										{{/if}}
									</div>
								</td>
							{{/if}}

							{{#if target.isFailed}}
								<td
									class="results-table_row_stats_subrow_cell cell probe-failed"
									colspan="{{tableColumns.length}}"
									style="grid-column: span {{tableColumns.length}};">
									<span class="probe-failed_content">
										<span>{{_.getGpFailureStatusText(target.failureSource)}}</span>
										<img class="probe-failed_icon" width="20" height="20" alt="" src="{{@shared.assetsHost}}/img/target-icon.svg" as-tooltip="`${target.failureRawOutput}`, 'top', true">
									</span>
								</td>
							{{elseif target.isOffline && !isInfiniteModeRes}}
								<td
									class="results-table_row_stats_subrow_cell cell probe-offline"
									colspan="{{tableColumns.length}}"
									style="grid-column: span {{tableColumns.length}};">
									<span>{{PROBE_OFFLINE_TEXT}}</span>
								</td>
							{{else}}
								{{#each tableColumns as column : columnIdx}}
									<td class="results-table_row_stats_subrow_cell cell {{column.className}} {{#if column.type !== 'timings' && column.sortable !== false}}is-sortable{{/if}} {{#if column.type === 'dns-response' && target.tableCells[columnIdx].hasStatus}}has-dns-status{{/if}}">
										<div class="cell-value">
											<span class="cell-label">{{column.mobileLabel || column.label}}</span>

											{{#if column.type === 'timings'}}
												<div class="timings-group">
													{{#each column.timings as timing : timingIdx}}
														<span class="timings {{#if target.tableCells[columnIdx].timings[timingIdx].value === PROBE_NO_TIMING_VALUE || !target.tableCells[columnIdx].timings[timingIdx].hasValue}}no-value{{/if}} {{#if timing.sortable !== false}}is-sortable{{/if}}">
															<span class="timings_header">{{timing.mobileLabel || timing.label}}</span>

															{{#if target.tableCells[columnIdx].timings[timingIdx].value === PROBE_NO_TIMING_VALUE}}
																<span class="timings_value timeout">{{PROBE_NO_TIMING_VALUE}}</span>
															{{elseif target.tableCells[columnIdx].timings[timingIdx].hasValue}}
																<span class="timings_value">
																	{{@this.formatTimingValue(target.tableCells[columnIdx].timings[timingIdx].value)}}
																	{{#if target.tableCells[columnIdx].timings[timingIdx].units}}
																		<span class="timings_units">{{target.tableCells[columnIdx].timings[timingIdx].units}}</span>
																	{{/if}}
																</span>
															{{elseif testInProgress}}
																<c-placeholder-skeleton type="base"></c-placeholder-skeleton>
															{{else}}
																<span class="timings_value">&mdash;</span>
															{{/if}}
														</span>

														{{#unless timing.isLast}}
															<span class="timings_separator">/</span>
														{{/unless}}
													{{/each}}
												</div>

												{{#if target.tableCells[columnIdx].showDesktopUnits}}
													<span class="lg-screen-units">ms</span>
												{{/if}}
											{{elseif column.type === 'dns-response'}}
												<span class="dns-response_content">
													<span class="dns-response_status-field">
														<span class="dns-response_mobile-label">Status</span>
														{{#if target.tableCells[columnIdx].hasStatus}}
															<span class="dns-response_status">{{target.tableCells[columnIdx].status}}</span>
														{{elseif testInProgress}}
															<c-placeholder-skeleton type="base"></c-placeholder-skeleton>
														{{else}}
															<span class="dns-response_status">&mdash;</span>
														{{/if}}
													</span>

													<span class="dns-response_answers-field">
														<span class="dns-response_mobile-label">Answers</span>
														{{#if target.isInProgress}}
															{{#if testInProgress}}
																<c-placeholder-skeleton type="base"></c-placeholder-skeleton>
															{{else}}
																<span>&mdash;</span>
															{{/if}}
														{{elseif target.tableCells[columnIdx].hasValue}}
															<span class="answers-count">{{target.tableCells[columnIdx].value.length}}</span>
															<span
																class="answers-list"
																style="grid-template-columns: minmax(0, {{dnsAnswerGridWidths[targetIdx].name}}ch) minmax(0, {{dnsAnswerGridWidths[targetIdx].ttl}}ch) minmax(0, {{dnsAnswerGridWidths[targetIdx].type}}ch) minmax(0, {{dnsAnswerGridWidths[targetIdx].value}}ch);">
																{{#each target.tableCells[columnIdx].value as answer}}
																	<span class="answers-list_row">
																		<span class="answers-list_name">{{answer.name}}</span>
																		<span class="answers-list_ttl">{{answer.ttl}}</span>
																		<span class="answers-list_type">{{answer.type}}</span>
																		<span class="answers-list_value">{{answer.value}}</span>
																	</span>
																{{/each}}
															</span>
														{{else}}
															<span class="answers-count">0</span>
															<span class="answers-empty dns-response_empty">No answers</span>
														{{/if}}
													</span>
												</span>
											{{elseif column.type === 'dns-answers' && target.isInProgress}}
												{{#if testInProgress}}
													<c-placeholder-skeleton type="base"></c-placeholder-skeleton>
												{{else}}
													<span>&mdash;</span>
												{{/if}}
											{{elseif column.type === 'dns-answers'}}
												{{#if target.tableCells[columnIdx].hasValue}}
													<span class="answers-count">{{target.tableCells[columnIdx].value.length}}</span>
													<span
														class="answers-list"
														style="grid-template-columns: minmax(0, {{dnsAnswerGridWidths[targetIdx].name}}ch) minmax(0, {{dnsAnswerGridWidths[targetIdx].ttl}}ch) minmax(0, {{dnsAnswerGridWidths[targetIdx].type}}ch) minmax(0, {{dnsAnswerGridWidths[targetIdx].value}}ch);">
														{{#each target.tableCells[columnIdx].value as answer}}
															<span class="answers-list_row">
																<span class="answers-list_name">{{answer.name}}</span>
																<span class="answers-list_ttl">{{answer.ttl}}</span>
																<span class="answers-list_type">{{answer.type}}</span>
																<span class="answers-list_value">{{answer.value}}</span>
															</span>
														{{/each}}
													</span>
												{{else}}
													<span class="answers-count">0</span>
													<span class="answers-empty">No answers</span>
												{{/if}}
											{{elseif column.type === 'ip'}}
												{{#if target.tableCells[columnIdx].hasValue}}
													<span class="visible-lg">
														{{#each splitIPv6(target.tableCells[columnIdx].value) as line}}
															{{line}}<br>
														{{/each}}
													</span>
													<span class="hidden-lg text-ellipsis">{{target.tableCells[columnIdx].value}}</span>
												{{elseif testInProgress}}
													<c-placeholder-skeleton type="base"></c-placeholder-skeleton>
												{{else}}
													<span>&mdash;</span>
												{{/if}}
											{{elseif column.type === 'graph'}}
												{{#if target.tableCells[columnIdx].value && target.tableCells[columnIdx].value.length}}
													<div>{{{ @this.createGraph(target.tableCells[columnIdx].value) }}}</div>
												{{elseif testInProgress}}
													<c-placeholder-skeleton type="base"></c-placeholder-skeleton>
												{{else}}
													<span>&mdash;</span>
												{{/if}}
											{{else}}
												{{#if target.tableCells[columnIdx].hasValue}}
													<span>{{target.tableCells[columnIdx].value}}</span>
												{{elseif testInProgress}}
													<c-placeholder-skeleton type="base"></c-placeholder-skeleton>
												{{else}}
													<span>&mdash;</span>
												{{/if}}
											{{/if}}
										</div>
									</td>
								{{/each}}
							{{/if}}
						</tr>
					{{/each}}
				</tbody>
			{{/each}}
		</table>
	</div>

	{{#if floatingSetLocationButton.visible}}
		<div class="c-gp-results-table-output_set-location-hitarea"
			style="top: {{floatingSetLocationButton.top}}px; left: {{floatingSetLocationButton.left-4}}px; height: {{floatingSetLocationButton.height}}px;"
			on-mouseleave="@this.hideSetLocationButton(@event)">
			<button class="c-gp-results-table-output_set-location {{#if itemFocused}}focus-outline{{/if}}"
				type="button"
				tabindex="-1"
				style="top: {{floatingSetLocationButton.buttonTop}}px;"
				as-tooltip="'Set as location for the next test', 'right'"
				on-focus="@this.set('itemFocused', true)"
				on-blur="@this.hideSetLocationButton(@event)"
				on-click="@this.setProbeAsLocation()"
				aria-label="Set as location for the next test">
				<i class="fa fa-map-marker" aria-hidden="true"></i>
			</button>
		</div>
	{{/if}}
</div>

<script>
	const _ = require('../../assets/js/_');
	const tooltip = require('../../assets/js/decorators/tooltip');
	const listeners = require('../../assets/js/utils/listeners');
	const PROBE_MAX_TIMING = 200;
	const PROBE_MIN_TIMING = 5;
	const PROBE_NO_TIMING_VALUE = _.getProbeTimeOutValue();
	const PROBE_OFFLINE_TEXT = 'Probe offline';
	const DNS_ANSWER_COLUMN_WIDTH_LIMITS = { name: 36, ttl: 10, type: 10, value: 40 };

	component.exports = {
		decorators: {
			tooltip,
		},
		data () {
			return {
				_,
				PROBE_NO_TIMING_VALUE,
				PROBE_OFFLINE_TEXT,
				splitIPv6 (address) {
					let segments = address.split(':');

					if (segments.filter(Boolean).length <= 4) {
						return [ address ];
					}

					let splitAt = segments[3] ? 4 : 3;

					return [ segments.slice(0, splitAt).join(':'), ':' + segments.slice(splitAt).join(':') ];
				},
				chartMaxHeight: 0,
				sortBy: 'location',
				sortOrder: 'asc',
				floatingSetLocationButton: {
					visible: false,
					top: 0,
					left: 0,
					height: 0,
					buttonTop: 0,
					clientSideId: null,
				},
				itemFocused: false,
				justFocusedItem: false,
			};
		},
		computed: {
			dnsAnswerGridWidths () {
				let columns = this.get('tableColumns') || [];
				let answersColumnIdx = columns.findIndex(column => [ 'dns-response', 'dns-answers' ].includes(column.type));
				let createWidths = () => ({ name: 1, ttl: 1, type: 1, value: 1 });
				let sharedWidths = createWidths();
				let widthsByTarget = Array.from({ length: this.get('targetsCnt') || 1 }, createWidths);

				if (answersColumnIdx < 0) {
					return widthsByTarget;
				}

				(this.get('preparedTestResults') || []).forEach((result) => {
					(result.statsPerTarget || []).forEach((target, targetIdx) => {
						let answers = target.tableCells?.[answersColumnIdx]?.value || [];

						answers.forEach((answer) => {
							Object.keys(sharedWidths).forEach((key) => {
								let length = String(answer[key] ?? '').length;

								sharedWidths[key] = Math.min(Math.max(sharedWidths[key], length), DNS_ANSWER_COLUMN_WIDTH_LIMITS[key]);
								widthsByTarget[targetIdx][key] = Math.min(Math.max(widthsByTarget[targetIdx][key], length), DNS_ANSWER_COLUMN_WIDTH_LIMITS[key]);
							});
						});
					});
				});

				let screenWidth = this.get('screenWidth');
				let useTargetWidths = screenWidth >= _.screenType.tablet
					&& screenWidth < _.screenType.lgDesktop && this.get('targetsCnt') > 1;

				return useTargetWidths ? widthsByTarget : widthsByTarget.map(() => sharedWidths);
			},
		},
		hasMultilineDnsAnswers (result) {
			let answersColumnIdx = (this.get('tableColumns') || []).findIndex(column => [ 'dns-response', 'dns-answers' ].includes(column.type));

			return answersColumnIdx >= 0 && (result.statsPerTarget || [])
				.some(target => (target.tableCells?.[answersColumnIdx]?.value?.length || 0) > 1);
		},
		onrender () {
			if (!Ractive.isServer) {
				listeners.screenWidthListener(this);

				this.observe('screenWidth', () => {
					this.setResultsBlockHeight(this.get('preparedTestResults') || []);
				});

				this.observe('preparedTestResults', () => {
					let preparedTestResults = this.get('preparedTestResults') || [];
					let tableColumns = this.get('tableColumns') || [];

					if (tableColumns.some(column => column.type === 'graph')) {
						this.setChartMaxHeight(preparedTestResults);
					} else if (this.get('chartMaxHeight') !== 0) {
						this.set('chartMaxHeight', 0);
					}

					// set results block height based on content
					this.setResultsBlockHeight(preparedTestResults);
				});

				this.observe('sortOrder sortBy', () => {
					let listWrapperEl = this.find('.results-table-wrapper');

					if (listWrapperEl) {
						listWrapperEl.scrollTop = 0;
					}
				}, { init: false });

				this._onSetLocationViewportChange = (event) => {
					this.hideSetLocationButton(event);
				};

				listeners.addManagedListener(this, window, 'resize', this._onSetLocationViewportChange);
				listeners.addManagedListener(this, window, 'scroll', this._onSetLocationViewportChange);
			}
		},
		onunrender () {
			if (this.resultsBlockHeightAnimationFrame) {
				cancelAnimationFrame(this.resultsBlockHeightAnimationFrame);
			}
		},
		// --- set location button logic ---
		isSetLocationFocusActive (setLocationButton) {
			let activeElement = document.activeElement;

			return (setLocationButton && setLocationButton.contains(activeElement))
				|| activeElement?.classList.contains('results-table_row')
				|| activeElement?.classList.contains('results-table_row_location');
		},
		showSetLocationButton (clientSideId) {
			let rowNode = this.find(`.item-id-${clientSideId}`);
			let rowLocation = rowNode?.querySelector('.results-table_row_location');
			let container = this.find('.c-gp-results-table-output');
			let listContainer = this.find('.results-table-wrapper');

			this.set('itemFocused', false);

			if (!rowNode || !rowLocation || !container || !listContainer) { return; }

			let listRect = listContainer.getBoundingClientRect();
			let rowLocationRect = rowLocation.getBoundingClientRect();
			let visibilityOverflowTolerancePx = 15;
			let isRowLocationVisible = rowLocationRect.top >= (listRect.top - visibilityOverflowTolerancePx)
				&& rowLocationRect.bottom <= (listRect.bottom + visibilityOverflowTolerancePx);

			if (!isRowLocationVisible) {
				this.set('floatingSetLocationButton.visible', false);
				return;
			}

			let rowRect = rowNode.getBoundingClientRect();

			if (!rowRect.height) {
				rowRect = rowLocationRect;
			}

			let containerRect = container.getBoundingClientRect();
			let relativeTop = rowRect.top - containerRect.top;
			let relativeLeft = rowLocationRect.left - containerRect.left;

			this.set('floatingSetLocationButton', {
				visible: true,
				clientSideId,
				top: relativeTop,
				left: relativeLeft - 26,
				height: rowRect.height,
				buttonTop: rowLocationRect.top - rowRect.top + rowLocationRect.height / 2 - 13,
			});
		},
		hideSetLocationButtonIfMoved () {
			let floatingSetLocationButton = this.get('floatingSetLocationButton');

			if (!floatingSetLocationButton.visible) {
				return;
			}

			let rowNode = this.find(`.item-id-${floatingSetLocationButton.clientSideId}`);
			let rowLocation = rowNode?.querySelector('.results-table_row_location');
			let container = this.find('.c-gp-results-table-output');

			if (!rowNode || !rowLocation || !container) {
				this.set('itemFocused', false);
				this.set('floatingSetLocationButton.visible', false);
				return;
			}

			let rowRect = rowNode.getBoundingClientRect();
			let rowLocationRect = rowLocation.getBoundingClientRect();

			if (!rowRect.height) {
				rowRect = rowLocationRect;
			}

			let containerRect = container.getBoundingClientRect();
			let top = rowRect.top - containerRect.top;
			let left = rowLocationRect.left - containerRect.left - 26;
			let height = rowRect.height;
			let buttonTop = rowLocationRect.top - rowRect.top + rowLocationRect.height / 2 - 13;
			let moved = (current, previous) => Math.abs(current - previous) > .5;

			if (moved(top, floatingSetLocationButton.top)
				|| moved(left, floatingSetLocationButton.left)
				|| moved(height, floatingSetLocationButton.height)
				|| moved(buttonTop, floatingSetLocationButton.buttonTop)) {
				this.set('itemFocused', false);
				this.set('floatingSetLocationButton.visible', false);
			}
		},
		hideSetLocationButton (event) {
			if (this.get('justFocusedItem')) {
				if (event?.type !== 'scroll') {
					this.set('justFocusedItem', false);
				}

				return;
			}

			if (event?.type === 'scroll') {
				this.set('floatingSetLocationButton.visible', false);
				this.set('itemFocused', false);
				return;
			}

			if (!this.get('floatingSetLocationButton.visible') && !this.get('itemFocused')) {
				return;
			}

			let setLocationButton = this.find('.c-gp-results-table-output_set-location');
			let setLocationHitarea = this.find('.c-gp-results-table-output_set-location-hitarea');

			if (event?.type === 'blur' && !event.relatedTarget) {
				requestAnimationFrame(() => {
					this.hideSetLocationButton();
				});

				return;
			}

			if (this.isSetLocationFocusActive(setLocationButton)) {
				return;
			}

			if (event?.type === 'blur' && setLocationButton?.contains(event.relatedTarget)) {
				return;
			}

			if (event && event.relatedTarget && event.type !== 'blur') {
				let container = event.target.closest('.results-table_row');
				let relatedContainer = event.relatedTarget.closest?.('.results-table_row');

				if ((container && container.contains(event.relatedTarget))
					|| relatedContainer
					|| (setLocationHitarea && setLocationHitarea.contains(event.relatedTarget))) {
					return;
				}
			}

			this.set('floatingSetLocationButton.visible', false);
			this.set('itemFocused', false);
		},
		setProbeAsLocation (clientSideId = this.get('floatingSetLocationButton.clientSideId')) {
			let probeData = (this.get('preparedTestResults') || []).find(item => item.clientSideId === clientSideId);

			if (!probeData) {
				this.set('itemFocused', false);
				this.set('floatingSetLocationButton.visible', false);
				return;
			}

			this.set('currSearchLocation', `${probeData.city}+AS${probeData.asn}`);
			this.set('floatingSetLocationButton.visible', false);
		},
		enableItemFocused (event, clientSideId) {
			if (!event.target?.classList.contains('results-table_row')
				&& !event.target?.classList.contains('results-table_row_location')) {
				return;
			}

			this.showSetLocationButton(clientSideId);
			this.set('itemFocused', true);
			this.set('justFocusedItem', true);

			requestAnimationFrame(() => {
				this.set('justFocusedItem', false);
			});
		},
		headerKeydownHandler (event, clientSideId) {
			if (!event.target?.classList.contains('results-table_row')
				&& !event.target?.classList.contains('results-table_row_location')) {
				return;
			}

			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault();
				this.setProbeAsLocation(clientSideId);
			}
		},
		setChartMaxHeight (results) {
			let chartMaxHeight = 0;

			results.forEach((result) => {
				result.statsPerTarget?.forEach((target) => {
					target.packetsRtt?.forEach((value) => {
						if (typeof value === 'number') {
							chartMaxHeight = Math.max(chartMaxHeight, value);
						}
					});
				});
			});

			this.set('chartMaxHeight', chartMaxHeight);
		},
		setResultsBlockHeight (results) {
			if (this.resultsBlockHeightAnimationFrame) {
				cancelAnimationFrame(this.resultsBlockHeightAnimationFrame);
			}

			this.resultsBlockHeightAnimationFrame = requestAnimationFrame(() => {
				this.resultsBlockHeightAnimationFrame = null;
				this.hideSetLocationButtonIfMoved();

				let listWrapperEl = this.find('.results-table-wrapper');

				if (!listWrapperEl) { return; }

				let itemEls = listWrapperEl.querySelectorAll('.results-table_row');

				if (!results.length || !itemEls.length) {
					listWrapperEl.style.height = '';
					return;
				}

				let limit = Math.min(itemEls.length, 8);
				let lastItemEl = itemEls[limit - 1];
				let lastItemRect = lastItemEl.getBoundingClientRect();
				let lastItemEnd = lastItemRect.bottom;

				// fallback for rows using display: contents
				if (!lastItemRect.height) {
					let renderedCellRects = [ ...lastItemEl.querySelectorAll('td') ]
						.map(cell => cell.getBoundingClientRect())
						.filter(rect => rect.height);

					if (!renderedCellRects.length) { return; }

					lastItemEnd = Math.max(...renderedCellRects.map(rect => rect.bottom));
				}

				let wrapperTop = listWrapperEl.getBoundingClientRect().top;
				let targetHeight = lastItemEnd - wrapperTop + listWrapperEl.scrollTop;

				listWrapperEl.style.height = `${Math.ceil(targetHeight)}px`;
			});
		},
		createRealTimeGraph (
			data,
			svgWidth = 48,
			svgHeight = 24,
			svgBgColor = '#F4F4F4',
			barWidth = 2,
			gap = 1,
		) {
			let maxValue = this.get('chartMaxHeight');

			if (!data?.length || (maxValue === 0 && !data.includes(PROBE_NO_TIMING_VALUE))) { return; }

			let maxBars = Math.floor(svgWidth / (barWidth + gap));
			let startIndex = Math.max(data.length - maxBars, 0);
			let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

			svg.setAttribute('width', svgWidth);
			svg.setAttribute('height', svgHeight);
			svg.style.backgroundColor = svgBgColor;

			for (let i = startIndex; i < data.length; i++) {
				let percentage = data[i] === maxValue || data[i] === PROBE_NO_TIMING_VALUE ? 1 : data[i] / maxValue;
				let barHeight = percentage * svgHeight;
				let x = svgWidth - ((data.length - 1 - i) * (barWidth + gap)) - barWidth;
				let y = svgHeight - barHeight;

				if (x >= 0) {
					let rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');

					rect.setAttribute('x', x);
					rect.setAttribute('y', y);
					rect.setAttribute('width', barWidth);
					rect.setAttribute('height', barHeight);
					rect.setAttribute('fill', this.pickBarColor(data[i]));
					svg.appendChild(rect);
				}
			}

			return svg.outerHTML;
		},
		createRegularGraph (
			data,
			svgWidth = 48,
			svgHeight = 24,
			svgBgColor = '#F4F4F4',
		) {
			let maxValue = this.get('chartMaxHeight');

			if (!data?.length || (maxValue === 0 && !data.includes(PROBE_NO_TIMING_VALUE))) { return; }

			data = data.slice(-20);

			let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
			let numBars = data.length;
			let spaceWidth = 1;
			let barWidth = Math.round(svgWidth / numBars - spaceWidth);
			let actualWidth = barWidth * numBars + (numBars - 1) * spaceWidth;

			svg.setAttribute('width', actualWidth > svgWidth ? actualWidth : svgWidth);
			svg.setAttribute('height', svgHeight);
			svg.style.backgroundColor = svgBgColor;

			data.forEach((value, index) => {
				let barHeight = value === PROBE_NO_TIMING_VALUE ? svgHeight : (value / maxValue) * svgHeight;
				let xPosition = index * spaceWidth + index * barWidth;
				let rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');

				rect.setAttribute('x', xPosition);
				rect.setAttribute('y', svgHeight - barHeight);
				rect.setAttribute('width', barWidth);
				rect.setAttribute('height', barHeight);
				rect.setAttribute('fill', this.pickBarColor(value));
				svg.appendChild(rect);
			});

			return svg.outerHTML;
		},
		pickBarColor (timing) {
			if (timing === PROBE_NO_TIMING_VALUE) {
				return _.getGpProbeStatusColor(timing);
			}

			function getColorFromGradient (quotient, start, middle, end) {
				return quotient >= 0.5 ? linear(middle, end, (quotient - 0.5) * 2) : linear(start, middle, quotient * 2);
			}

			function linear (startColor, endColor, quotient) {
				let redColor = byteLinear(startColor[1] + startColor[2], endColor[1] + endColor[2], quotient);
				let greenColor = byteLinear(startColor[3] + startColor[4], endColor[3] + endColor[4], quotient);
				let blueColor = byteLinear(startColor[5] + startColor[6], endColor[5] + endColor[6], quotient);

				return `#${redColor}${greenColor}${blueColor}`;
			}

			function byteLinear (partOne, partTwo, quotient) {
				let color = Math.floor(('0x' + partOne) * (1 - quotient) + ('0x' + partTwo) * quotient);

				return color.toString(16).padStart(2, '0');
			}

			let pureTimingValue = parseInt(timing);

			// '#17d4a7', '#ffb800', '#e64e3d' - colors are used for timings scale on the map
			if (pureTimingValue <= PROBE_MIN_TIMING) {
				return '#17d4a7';
			}

			if (pureTimingValue >= PROBE_MAX_TIMING) {
				return '#e64e3d';
			}

			return getColorFromGradient(pureTimingValue / PROBE_MAX_TIMING, '#17d4a7', '#ffb800', '#e64e3d');
		},
		calcQuality (statsTotal, statsDrop) {
			if (
				typeof statsTotal === 'undefined'
				|| typeof statsDrop === 'undefined'
				|| statsTotal === 0
			) {
				return {
					qualityPercentage: null,
					actualAmount: null,
				};
			}

			let actualAmount = Math.max(statsTotal - statsDrop, 0);
			let qualityPercentage = Math.round(actualAmount / statsTotal * 100);

			return {
				qualityPercentage,
				actualAmount,
			};
		},
		createGraph (packetsRtt) {
			let isInfiniteModeRes = this.get('isInfiniteModeRes');
			let memoizedCreateGraph;

			if (isInfiniteModeRes) {
				memoizedCreateGraph = _.memoize(this.createRealTimeGraph.bind(this));
			} else {
				memoizedCreateGraph = _.memoize(this.createRegularGraph.bind(this));
			}


			return memoizedCreateGraph(packetsRtt);
		},
		formatTimingValue (value) {
			if (typeof value !== 'number' || isNaN(value)) {
				return value;
			}

			if (value < 10) {
				return value.toFixed(2);
			} else if (value < 100) {
				return value.toFixed(1);
			}

			return Math.round(value);
		},
		onSortClick (field) {
			if (field === this.get('sortBy')) {
				this.set('sortOrder', this.get('sortOrder') === 'asc' ? 'desc' : 'asc');
			} else {
				this.set('sortBy', field);
				this.set('sortOrder', 'asc');
			}
		},
		toggleSortOrder () {
			this.set('sortOrder', this.get('sortOrder') === 'asc' ? 'desc' : 'asc');
		},
		getSortIcon (field) {
			if (field === this.get('sortBy')) {
				return `sort-${this.get('sortOrder')}-sm.svg`;
			}

			return 'sort-none.svg';
		},
	};
</script>
